import React from "react";
import { Link } from "react-router-dom";
import { Compass, Mail, Instagram, Youtube, MapPin } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSiteInfo, openCookiePreferences } from "@/lib/siteInfo";
import { CONTACT } from "@/lib/contactInfo";

export default function Footer() {
  const { t } = useLang();
  const info = useSiteInfo();
  return (
    <footer className="border-t border-copper/20 bg-obsidian2" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <Compass className="h-6 w-6 text-copper" />
            <span className="font-serif text-xl tracking-[0.18em] uppercase">De Los Cielos</span>
          </div>
          <p className="mt-4 font-serif italic text-xl text-cream2 max-w-xs">Dove Cielo e Terra si uniscono.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4">{t("footer.nav")}</p>
          <ul className="space-y-2.5 text-sm text-cream2">
            <li><Link className="link-underline" to="/viaggi" data-testid="footer-link-expeditions">{t("nav.expeditions")}</Link></li>
            <li><Link className="link-underline" to="/destinazioni" data-testid="footer-link-destinations">{t("nav.destinations")}</Link></li>
            <li><Link className="link-underline" to="/leader" data-testid="footer-link-leaders">{t("nav.leaders")}</Link></li>
            <li><Link className="link-underline" to="/chi-siamo" data-testid="footer-link-about">{t("nav.about")}</Link></li>
            <li><Link className="link-underline" to="/faq" data-testid="footer-link-faq">{t("nav.faq")}</Link></li>
            <li><Link className="link-underline" to="/contatti" data-testid="footer-link-contact">{t("nav.contact")}</Link></li>
            <li><Link className="link-underline" to="/admin/login" data-testid="footer-link-admin">{t("nav.area")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4">{t("footer.contact")}</p>
          <ul className="space-y-2.5 text-sm text-cream2">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-copper" /> {CONTACT.email}</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-copper" /> Roma, Italia</li>
            <li className="flex items-center gap-3 pt-2">
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="text-cream2 hover:text-copper transition-colors"><Instagram className="h-5 w-5" /></a>
              <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="footer-social-youtube" className="text-cream2 hover:text-copper transition-colors"><Youtube className="h-5 w-5" /></a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-x py-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <p className="font-mono text-[11px] text-sand">© 2026 De Los Cielos · {t("footer.rights")}</p>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[11px] uppercase tracking-[0.14em] text-sand" data-testid="footer-legal">
            <li><Link className="hover:text-copperlight transition-colors" to="/privacy" data-testid="footer-link-privacy">{t("legal.privacy")}</Link></li>
            <li><Link className="hover:text-copperlight transition-colors" to="/cookie-policy" data-testid="footer-link-cookie">{t("legal.cookie")}</Link></li>
            {info && info.other_cookies && (
              <li>
                <button type="button" onClick={openCookiePreferences} className="hover:text-copperlight transition-colors uppercase" data-testid="footer-cookie-preferences">
                  {t("legal.preferences")}
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    </footer>
  );
}
